export const primaryColor: string = "#51798b";
export const secondaryColor: string = "#89847b";
